export function safeWebsite(address) {
    if (address) {
        if (!address.match('^(http(s?):\/\/)')) {
            return 'http://' + address;
        }
        else {
            return address;
        }
    }
}
